import React, { useEffect, useState } from "react";
import LeagueSwitcher from "@/components/LeagueSwitcher";
import StandingsTable from "@/components/StandingsTable";
import { fetchStandings, fetchScorers } from "@/lib/api";
import { useI18n } from "@/i18n/I18nContext";

export default function Standings() {
  const { t } = useI18n();
  const [league, setLeague] = useState("world-cup");
  const [data, setData] = useState({ standings: [], league: null });
  const [scorers, setScorers] = useState([]);

  useEffect(() => {
    fetchStandings(league).then(setData);
    fetchScorers(league).then((d) => setScorers(d.scorers || []));
  }, [league]);

  return (
    <div data-testid="standings-page" className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-8 py-10">
      <div className="border-b border-white/10 pb-6">
        <h1 className="font-display text-5xl sm:text-6xl uppercase tracking-tighter">{t("standings.title")}</h1>
        <p className="text-sm text-white/50 mt-2">{t("standings.subtitle")}</p>
      </div>

      <div className="mt-6">
        <LeagueSwitcher value={league} onChange={setLeague} excludeAll />
      </div>

      <div className="mt-8 grid lg:grid-cols-3 gap-8">
        <div className="lg:col-span-2">
          <h2 className="font-display text-3xl uppercase tracking-tighter mb-4">{data.league?.name || "—"}</h2>
          <StandingsTable rows={data.standings} testId="full-standings-table" />
          <div className="mt-4 flex items-center gap-6 text-xs text-white/40">
            <div className="flex items-center gap-2"><span className="w-2 h-3 bg-volt" /> {t("standings.cl_spot")}</div>
            <div className="flex items-center gap-2"><span className="w-2 h-3 bg-[#FF9500]" /> {t("standings.eur_spot")}</div>
          </div>
        </div>

        <div>
          <h2 className="font-display text-3xl uppercase tracking-tighter mb-4">{t("section.topscorers")}</h2>
          <div className="border border-white/10 divide-y divide-white/5" data-testid="standings-page-scorers">
            {scorers.map((s) => (
              <div key={s.player} className="flex items-center gap-3 p-3 hover:bg-white/[0.03]">
                <span className="font-display text-xl text-volt w-6 tabular-nums">{s.rank}</span>
                <div className="w-9 h-9 bg-white/5 border border-white/10 flex items-center justify-center font-mono text-[10px]">
                  {s.team.logo}
                </div>
                <div className="flex-1 min-w-0">
                  <div className="text-sm truncate">{s.player}</div>
                  <div className="text-xs text-white/40 truncate">{s.team.name}</div>
                </div>
                <div className="text-right">
                  <div className="font-display text-2xl tabular-nums">{s.goals}</div>
                  <div className="text-[10px] uppercase tracking-[0.2em] text-white/40">G {s.assists}A</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
